import { render, staticRenderFns } from "./AppDetailTab5.vue?vue&type=template&id=34ef7d43&scoped=true";
import script from "./AppDetailTab5.vue?vue&type=script&lang=js";
export * from "./AppDetailTab5.vue?vue&type=script&lang=js";
import style0 from "./AppDetailTab5.vue?vue&type=style&index=0&id=34ef7d43&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "34ef7d43", null);
export default component.exports;